var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 14.9993C3.33203 14.1153 3.68322 13.2674 4.30834 12.6423C4.93346 12.0172 5.78131 11.666 6.66536 11.666H13.332C14.2161 11.666 15.0639 12.0172 15.6891 12.6423C16.3142 13.2674 16.6654 14.1153 16.6654 14.9993C16.6654 15.4414 16.4898 15.8653 16.1772 16.1779C15.8646 16.4904 15.4407 16.666 14.9987 16.666H4.9987C4.55667 16.666 4.13275 16.4904 3.82019 16.1779C3.50763 15.8653 3.33203 15.4414 3.33203 14.9993Z",
    stroke: "#EAEAEA",
    strokeWidth: 0.833333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.33301C11.3807 8.33301 12.5 7.21372 12.5 5.83301C12.5 4.4523 11.3807 3.33301 10 3.33301C8.61929 3.33301 7.5 4.4523 7.5 5.83301C7.5 7.21372 8.61929 8.33301 10 8.33301Z",
    stroke: "#EAEAEA",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.87f2e7ff677e5c895df74005737cec7e.svg";
export { ForwardRef as ReactComponent };